import { headquartersService } from '@/services'

export default {
  state: {
    announcements: []
  },

  mutations: {
    setAnnouncements (state, value) {
      state.announcements = value
    },

    createAnnouncement (state, value) {
      const announcements = state.announcements
      announcements.unshift(value)

      state.announcements = announcements
    },

    deleteAnnouncement (state, id) {
      state.announcements = state.announcements.filter(item => item.id !== id)
    },

    updateAnnouncement (state, value) {
      state.announcements = state.announcements.map(item => {
        if (item.id === value.id) {
          return value
        } else {
          return item
        }
      })
    }
  },

  actions: {
    getAnnouncements ({ commit }) {
      return headquartersService.getAll().then(({ data }) => {
        commit('setAnnouncements', data.announcements)
      }).catch(({ data }) => Promise.reject(data))
    },

    createAnnouncement ({ commit }) {
      return headquartersService.create({
        title: 'New announcement',
        subTitle: 'description'
      })
        .then(({ data }) => commit('createAnnouncement', data))
        .catch(({ data }) => Promise.reject(data))
    },

    updateAnnouncement ({ commit }, value) {
      commit('updateAnnouncement', value)
      return headquartersService.update(value)
    },

    deleteAnnouncement ({ commit }, id) {
      commit('deleteAnnouncement', id)
      return headquartersService.delete(id)
    }
  }
}
